import { Typography } from "@mui/material";
import { Skeleton } from "@mui/material";
import { Autocomplete } from "components/Autocomplete";
import PropTypes from "prop-types";
import { useSitesQuery } from "hooks/queries/useSitesQuery";

export function SiteDropdown({ value, onChange, ...rest }) {
  const { isLoading, isError, data: sites } = useSitesQuery();

  if (isLoading) {
    return <Skeleton variant="rectangular" width="100%" height={56} />;
  }

  if (isError) {
    return <Typography>An error occurred</Typography>;
  }

  return (
    <Autocomplete
      value={value}
      loading={isLoading}
      error={isError}
      onChange={onChange}
      label="Site"
      options={sites.results}
      variant="outlined"
      getOptionLabel={option => option.name}
      fullWidth
      {...rest}
    />
  );
}

SiteDropdown.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func
};
